/**
 =========================================================
 * Material Dashboard 2 React - v2.1.0
 =========================================================
 
 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)
 
 Coded by www.creative-tim.com
 
 =========================================================
 
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */
import 'regenerator-runtime/runtime';

import '@fontsource/roboto/latin-300.css';
import '@fontsource/roboto/latin-400.css';
import '@fontsource/roboto/latin-500.css';
import '@fontsource/roboto/latin-700.css';
import 'pages/entities/index.css';

import '@fontsource/material-icons';
import '@fontsource/material-icons-rounded';
import '@fontsource/material-icons-outlined';
import '@fontsource/material-icons-sharp';
import '@fontsource/material-icons-two-tone';

import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import { MaterialUIControllerProvider } from 'context';
import LocaleProvider from 'components/LocaleProvider';
import { CookiesProvider } from 'react-cookie';
import { PersistGate } from 'redux-persist/integration/react';
import { createRoot } from 'react-dom/client';
import OIDCAuthProvider from 'components/Security/OIDCAuthProvider';
import { ReactNotifications } from 'react-notifications-component';
import store, { persistor } from './store';
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <HelmetProvider>
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <CookiesProvider>
          <LocaleProvider>
            <HashRouter>
              <MaterialUIControllerProvider>
                <ReactNotifications isMobile />
                <OIDCAuthProvider>
                  <App />
                </OIDCAuthProvider>
              </MaterialUIControllerProvider>
            </HashRouter>
          </LocaleProvider>
        </CookiesProvider>
      </PersistGate>
    </ReduxProvider>
  </HelmetProvider>
);
